import { CommentItem, Vendor } from "@finway-group/shared/lib/models"
import axios from "axios"

import store from "Shared/store"

const VendorService = {
    getVendorById: (id: string): Vendor => store.getState().vendors.items.find((vendor: Vendor) => vendor.id === id),
    update: async (id: string, updatedVendor: Vendor) => {
        const { data } = await axios.put(`/vendors/${id}`, updatedVendor)
        return new Vendor(data)
    },
    create: async (newVendor: Vendor) => {
        const { data } = await axios.post(`/vendors`, newVendor)
        return new Vendor(data)
    },
    fetchOneVendor: async (id: string) => {
        const { data } = await axios.get(`/vendors/${id}`)
        return new Vendor(data)
    },
    deleteOneVendor: async (id: string) => {
        await axios.delete(`/vendors/${id}`)
    },
    updateComment: async (id: string, comments: CommentItem[]) => {
        const { data } = await axios.put(`/vendors/${id}/comments`, comments)
        return new Vendor(data)
    },
    updateVendorRule: async (id: string, rule: any) => {
        const { data } = await axios.put(`/vendors/${id}/rule`, rule)
        return new Vendor(data)
    },
    approveVendorStatus: async (id: string) => {
        const { data } = await axios.put(`/vendors/${id}/approve`)
        return new Vendor(data)
    },
    fetchAllVendors: async () => {
        const {
            data: { docs },
        } = await axios.get(`vendors?limit=10000&sortBy=desc(createdAt)`)
        return docs.map((vendor: any) => new Vendor(vendor))
    },
    getLatestVendorCreditorNumber: async () => {
        const {
            data: { creditorNumberSequence },
        } = await axios.get("/vendors/sequence/latest-creditor-number")
        return creditorNumberSequence
    },
    export: async () => {
        await axios.post("/vendors/export")
    }
}

export default VendorService
